// Mirrors _features/userManagement/state/slice.js's shape. Drops the old
// features/rolesFeature/slice.js's `customColumns` field - Roles has no
// per-org customizable columns (the list page passes tableCol={[]}/
// isInternalCustomize={false} to <Filter>, so the old field was threaded
// through but never actually exercised by real UI).
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const DEFAULT_SORT = "-createdAt";

const initialState = {
  selectedFilters: {
    sort: DEFAULT_SORT,
  },
};

const rolesFeatureSlice = createSlice({
  name: "rolesFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: DEFAULT_SORT,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.rolesFeature) {
        const persistedFilters = action.payload.rolesFeature.selectedFilters;

        return {
          ...state,
          selectedFilters: {
            ...(persistedFilters && typeof persistedFilters === "object" ? persistedFilters : {}),
            sort: persistedFilters?.sort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } = rolesFeatureSlice.actions;

export default rolesFeatureSlice.reducer;
